import { useContext, useState } from "react";
import {
  Box,
  Stack,
  Collapse,
  TextField,
  Typography,
  IconButton,
  Tooltip,
  Menu,
  FormControl,
  Select,
  MenuItem,
  Radio,
} from "@mui/material";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DisabledByDefaultRoundedIcon from "@mui/icons-material/DisabledByDefaultRounded";
import { FiEdit } from "react-icons/fi";
//Import from project
import { AuthContext } from "../../../Context/AuthContext";
import { TransitionGroup } from "react-transition-group";
import { SelectDatePicker } from "../../Include/SelectDatePicker/SelectDatePicker";

const AlertList = ({ listItemData, setListItemData, required }) => {
  const { t } = useContext(AuthContext);

  const newEntry = {
    paidAmount: 0,
    alertDate: null,
    status: "",
  };

  // console.log("listItemData::", listItemData);

  const handleAdd = () => {
    setListItemData((prev) => [...prev, newEntry]);
  };

  const handleRemove = (index) => {
    setListItemData((prev) => prev.filter((_, i) => i !== index));
  };

  const handleChangeValue = (index, value, field) => {
    // console.log("index, value, field...", index, value, field);
    setListItemData((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const [selectedValue, setSelectedValue] = useState("amount");

  const handleChange = (index, val, field) => {
    handleChangeValue(index, val, field);
    setSelectedValue(val);
    handleChangeValue(index, 0, "discount");
  };

  return (
    <Stack direction="column" spacing={2}>
      <Stack
        spacing={0.6}
        direction="row"
        alignItems="center"
        sx={{ borderBottom: "1px solid gray" }}
      >
        <Typography className={t("class-name-field-title")} width="25%">
          {t("thead_alert_date")}
        </Typography>

        {/* <Typography className={t("class-name-field-title")} width="10%">
          {t("thead_amount")}
        </Typography> */}

        <Box sx={{ width: "5%" }}>
          <IconButton onClick={handleAdd} title={t("add")}>
            <AddBoxIcon sx={{ color: "green" }} />
          </IconButton>
        </Box>
      </Stack>

      {/* List with TransitionGroup */}
      <TransitionGroup>
        {listItemData?.map((item, index) => {
          // console.log("item::", item);
          return (
            <Collapse key={index}>
              <Stack
                spacing={0.6}
                direction="row"
                alignItems="center"
                sx={{ mb: 1 }}
              >
                <Box width="25%">
                  <SelectDatePicker
                    value={item?.alertDate}
                    onChange={(val) =>
                      handleChangeValue(index, val, "alertDate")
                    }
                  />
                </Box>

                {/* <Box width="10%">
                  <TextField
                    fullWidth
                    size="small"
                    type="number"
                    className="text-field"
                    value={item?.price}
                    onChange={({ target }) =>
                      handleChangeValue(index, target?.value, "amount")
                    }
                    placeholder={t("thead_amount")}
                    InputProps={{
                      endAdornment: (
                        <Typography className={t("class-name-field-title")}>
                          $
                        </Typography>
                      ),
                    }}
                  />
                </Box> */}

                {/* <Box width="20%">
                  <FormControl size="small" fullWidth>
                    <Select
                      value={item?.status}
                      onChange={(e) =>
                        handleChangeValue(index, e.target.value, "status")
                      }
                    >
                      <MenuItem value="dropout">Dropout</MenuItem>
                      <MenuItem value="stopout">Stopout</MenuItem>
                    </Select>
                  </FormControl>
                </Box> */}

                <Box sx={{ width: "5%" }}>
                  <IconButton
                    onClick={() => handleRemove(index)}
                    title={t("remove")}
                  >
                    <DisabledByDefaultRoundedIcon sx={{ color: "red" }} />
                  </IconButton>
                </Box>
              </Stack>
            </Collapse>
          );
        })}
      </TransitionGroup>
    </Stack>
  );
};

export default AlertList;
